import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild
} from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { Language } from '@generated/base-types';
import { uiLanguageOptions } from '@new/common/language-options';
import { CurrentUserFragment } from '@new/common/services/current-user.generated';
import { WindowService } from '@new/common/services/window.service';
import { SetCurrentLanguage } from '@new/common/state/context';
import { IconButtonDirective } from '@new/common/ui/icon-button.directive';
import {
  SelectButtonComponent,
  SelectButtonOption
} from '@new/common/ui/select-button.component';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { Overlay } from 'primeng/overlay';
import { OverlayPanelModule } from 'primeng/overlaypanel';

@Component({
  selector: 'man-user-menu',
  templateUrl: './user-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    OverlayPanelModule,
    SelectButtonComponent,
    IconButtonDirective
  ]
})
export class UserMenuComponent implements AfterViewInit {
  @Input() public user: CurrentUserFragment;
  @ViewChild('op') public overlayPanel: Overlay;

  public languageOptions: SelectButtonOption[] = uiLanguageOptions.map(
    this.mapLanguageOption
  );

  constructor(
    private readonly windowService: WindowService,
    private router: Router,
    private store: Store
  ) {}

  public ngAfterViewInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.overlayPanel.hide();
      }
    });
  }

  public onLanguageChange(language: unknown): void {
    this.store.dispatch(new SetCurrentLanguage(language as Language));
  }

  public async onLogout(): Promise<void> {
    await fetch('/logout', { method: 'DELETE' });
    this.windowService.href = '/login';
  }

  private mapLanguageOption({
    value,
    label
  }: {
    label: string;
    value: string;
  }): SelectButtonOption {
    return {
      label: value.toUpperCase(),
      value: value,
      title: label
    };
  }
}
